import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "h2 text-center" }, "Grupos", -1)
const _hoisted_3 = { class: "row justify-content-center py-10 row-cols-1 row-cols-md-2 g-4" }
const _hoisted_4 = { class: "table border rounded bg-white table-striped-rows shadow" }
const _hoisted_5 = {
  class: "bg-primary",
  colspan: "4"
}
const _hoisted_6 = { class: "h3 text-center text-white" }
const _hoisted_7 = { class: "border text-center fw-bolder" }
const _hoisted_8 = { class: "border" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "border" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "border fw-bolder" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h4", { class: "h2 text-center" }, "Fixture", -1)
const _hoisted_15 = { class: "row justify-content-center py-10 row-cols-1 row-cols-md-2 g-4" }
const _hoisted_16 = { class: "h4 mb-4 text-center" }
const _hoisted_17 = { class: "d-flex" }
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = { class: "border text-center fw-bolde" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listGroups, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "col"
          }, [
            _createElementVNode("table", _hoisted_4, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_5, [
                    _createElementVNode("h5", _hoisted_6, "GRUPO " + _toDisplayString(item.grupo), 1)
                  ])
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.data, (subItem, subIndex) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: `sj-${subIndex}`
                  }, [
                    _createElementVNode("td", _hoisted_7, _toDisplayString(subItem.groupAsciiLetter) + _toDisplayString(subItem.orderGroup), 1),
                    _createElementVNode("td", _hoisted_8, [
                      _createElementVNode("img", {
                        class: "w-30px",
                        src: subItem.bandera
                      }, null, 8, _hoisted_9)
                    ]),
                    _createElementVNode("td", _hoisted_10, [
                      _createElementVNode("img", {
                        class: "w-30px",
                        src: subItem.image_path
                      }, null, 8, _hoisted_11)
                    ]),
                    _createElementVNode("td", _hoisted_12, _toDisplayString(subItem.business), 1),
                    _createElementVNode("td", {
                      class: "border text-center fw-bolder",
                      innerHTML: subItem.abrev
                    }, null, 8, _hoisted_13)
                  ]))
                }), 128))
              ])
            ])
          ]))
        }), 128))
      ])
    ])), [
      [_directive_loading, _ctx.loading]
    ]),
    _hoisted_14,
    _createElementVNode("div", _hoisted_15, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rowsFixture, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "col"
        }, [
          _createElementVNode("div", _hoisted_16, " GRUPO " + _toDisplayString(item.group), 1),
          _createElementVNode("div", _hoisted_17, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.fechas, (fecha, index) => {
              return (_openBlock(), _createElementBlock("table", {
                key: `ml-${index}`,
                class: "table border rounded bg-white table-striped-rows shadow"
              }, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, [
                      _createElementVNode("h4", _hoisted_18, "Fecha " + _toDisplayString(fecha.dateOrder), 1)
                    ])
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fecha.informacion, (sub, mela) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: `sub-itf${mela}`
                    }, [
                      _createElementVNode("td", _hoisted_19, _toDisplayString(item.group) + _toDisplayString(sub.orderGroup1) + " - " + _toDisplayString(item.group) + _toDisplayString(sub.orderGroup2), 1)
                    ]))
                  }), 128))
                ])
              ]))
            }), 128))
          ])
        ]))
      }), 128))
    ])
  ], 64))
}